import { ToolCallStrategy, ToolCall } from './BaseToolStrategy';
import { Message } from '@scale/shared/types/chat-completion';
import { FlamingoAgenticImagineToolSchemas } from './HardcodedToolCallSchemas';

interface FlamingoAgenticImagineToolCallRaw {
  name: string;
  parameters: {
    prompt: string;
    creation_type?: string;
    modification_type?: string;
    include_user?: string;
    file_paths?: string[];
  };
}

export class FlamingoAgenticImagineToolCallStrategy extends ToolCallStrategy {
  parseToolCalls(message: Message): ToolCall[] {
    try {
      // Tool calls are expected to be written to message.content as <|TOOL|>[tool_json]</|TOOL|>
      const toolCalls = message.content.split('<|TOOL|>')[1].split('</|TOOL|>')[0];
      const toolCallsParsed = JSON.parse(toolCalls) as FlamingoAgenticImagineToolCallRaw[];
      return toolCallsParsed.map(toolCall => ({
        functionName: toolCall.name,
        functionParameters: toolCall.parameters,
        functionMetadata: {},
      }));
    } catch (e) {
      // return an empty array if tool calls cannot be parsed
      return [];
    }
  }

  writeToolCalls(
    message: Message,
    toolCalls: ToolCall[],
  ): {
    message: Message;
    output: string;
  } {
    // Tool calls are written to message.content as <|TOOL|>[tool_json]</|TOOL|>
    const toolCallsJson = toolCalls.map(toolCall => ({
      name: toolCall.functionName,
      parameters: toolCall.functionParameters,
    }));
    const new_content = `<|TOOL|>${JSON.stringify(toolCallsJson)}</|TOOL|>`;
    return {
      message: {
        ...message,
        content: new_content,
      },
      output: new_content,
    };
  }

  getToolSchemas() {
    return FlamingoAgenticImagineToolSchemas;
  }
}
